<template>
    <div class="">
        <div class="title"> 企业用户登录 </div>
        <div>
            <div class="input-box m-b-5" :class="{
                error: !!errorText
            }">
                <input class="text-center" v-model="phone" type="text"  placeholder="请输入您的手机号">
            </div>
            <div class="error m-b-35">{{errorText}}</div>
            <div class="primary-btn m-b-14" @click="checkLogin">立即登录/注册</div>
            <div class="button green-btn flex flex-center" @click="goWx">
                <img :src="require('../../assets/images/wx_icon.png')" />
                微信快捷登录
            </div>
        </div>
    </div>
</template>
<script>
    const qs = require('qs');
    export default {
        data(){
            return {
                phone:'',
                errorText: ''
            }
        },
        methods:{
            checkLogin () { 
                // 验证是否已输入手机号，
                let errorText = ''
                const phone = this.phone
                if (!phone) {
                    errorText = '请输入手机号'
                } else if (phone.length != 11) {
                    errorText = '手机号格式错误'
                }
                this.errorText = errorText
                
                if (!!errorText) {
                    return 
                }
                // 并验证是否已注册
                this.axios.get('/wapi/hr/isReg?phone=' + phone)
                        .then(res => {
                            if (res.data.isReg == 1) {
                                this.$router.push({
                                    path:'/yzlogin',
                                    query: {
                                        phone
                                    }
                                })
                            } else {
                                this.$router.push({
                                    path:'/register',
                                    query: {
                                        phone
                                    }
                                })
                            }
                        }).catch(error => {
                            throw new Error(error);
                        })
            },
            goWx () {
                this.$router.push({
                    path:'/wxlogin'
                })
            }
        }
    }
</script>
<style lang="less" scoped>
@import url('../../assets/less/login.less');
</style>



// WEBPACK FOOTER //
// login.vue?bb459a94